module.exports = __webpack_public_path__ + "static/media/icon_zoom_out.4b2fbca3.svg";